import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Gallery from "@browniebroke/gatsby-image-gallery"

import Button from "../Button/Button"

const strings = {
  fr: {
    title: "Quelques réalisations avec le Précoffré® Thermique",
    btnString: "Toutes nos réalisations",
    btnURL: "/realisations/",
  },
  de: {
    title: "Unsere Referenzen mit Thermowand",
    btnString: "Alle unsere Erfolge",
    btnURL: "/de/unsere-referenzen/",
  },
  en: {
    title: "Some examples of constructions using the Precast Thermal wall",
    btnString: "All our achievements",
    btnURL: "/en/achievements/",
  },
}

const PrecoThermiqueImageGallery = ({ lang }) => {
  const data = useStaticQuery(graphql`
    {
      de_wohnen: file(
        name: { eq: "Wohnen-am-Bliessee-Ludwigshafen" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_vollinger: file(
        name: { eq: "Vollinger-und-Partner-Karlsruhe" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_mfh: file(
        name: { eq: "MFH-Karlsruhe" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_hockenheim: file(
        name: { eq: "Office-Pavillion-Hockenheim" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_fluchtlinge: file(
        name: { eq: "Fluchtlinge" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_ubstadt: file(
        name: { eq: "BV-Hotel-Ubstadt-Weiher" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      de_lidl: file(
        name: { eq: "Magasin-Lidl" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      creche_hidalgo: file(
        name: { eq: "precoffre-Thermique-creche-Hidalgo-Paris" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      espace_sportif_entzheim: file(
        name: { eq: "precoffre-thermique-espace-sportif-Entzheim" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      limonest: file(
        name: { eq: "Precoffre-Thermique-Bureaux-Limonest" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      luciline: file(
        name: { eq: "precoffre-thermique-logements-Luciline-Rouen" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      beaune: file(
        name: { eq: "Premur-thermique-Erea-Beaune" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      plerin: file(
        name: { eq: "precoffre-thermique-CFA-Plerin" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      varda: file(
        name: { eq: "college-Agnes-Varda-Ligne" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
      fontenay: file(
        name: { eq: "logements-Fontenay-sous-bois" }
        sourceInstanceName: { eq: "images" }
      ) {
        ...galleryImgs
      }
    }
  `)

  const captions = {
    fr: [
      "Creche Hidalgo - Paris : Architecte: Pascal Quintard Hofstein",
      "Espace sportif - Entzheim : Architecte: Auger Rambeaud Architectes",
      "Bureaux - Limonest : Architecte: AS Architecture Studio",
      "Logements Luciline - Rouen : Architecte: Agence Devillers & Associes",
      "Erea - Beaune : Architecte: XTO Architectes",
      "CFA - Plerin : Architecte Dunet & Associes",
      "College Agnes Varda - Ligne : Architecte: De Coquereaumont Lebreton Architectes",
      "Logements - Fontenay Sous Bois : Architecte: Baudouin Bergeron Architectes",
    ],
    de: [
      "Wohnen am Bliessee – Ludwigshafen",
      "Vollinger und Partners – Karlsruhe",
      "MFH – Karlsruhe",
      "Büros – Hockenheim",
      "Fluchtlinge - Oberhausern",
      "BV Hotel - Ubstadt Weiher",
      "Lidl Geschäft",
      "Hidalgo Kindergarten – Paris: Architekt: Pascal Quintard Hofstein",
      "Sportplatz - Entzheim: Architekt: Auger Rambeaud Architectes",
      "Büros - Limonest: Architekt: AS Architecture Studio",
      "Luciline Wohnungen - Rouen: Architekt: Agence Devillers &amp; Associes",
      "Kindergarten - Beaune: Architekt: XTO Architectes",
      "Lehrlingsausbildungszentrum - Plerin: Architekt: Dunet &amp; Associes",
      "Hochschule Agnès Varda – Ligne: Architekt: De Coquereaumont Lebreton Architectes",
      "Wohnungen - Fontenay Sous Bois: Architekt: Baudouin Bergeron Architectes",
    ],
    en: [
      "Creche Hidalgo - Paris : Architecte: Pascal Quintard Hofstein",
      "Espace sportif - Entzheim : Architecte: Auger Rambeaud Architectes",
      "Bureaux - Limonest : Architecte: AS Architecture Studio",
      "Logements Luciline - Rouen : Architecte: Agence Devillers & Associes",
      "Erea - Beaune : Architecte: XTO Architectes",
      "CFA - Plerin : Architecte Dunet & Associes",
      "College Agnes Varda - Ligne : Architecte: De Coquereaumont Lebreton Architectes",
      "Logements - Fontenay Sous Bois : Architecte: Baudouin Bergeron Architectes",
    ],
  }

  const imgsArr = Object.entries(data)
  const images = imgsArr.map((img, i) => {
    return {
      ...img[1].childImageSharp,
      title: captions[lang][i],
    }
  })
  const FRENImgsArr = imgsArr.filter((img) => !img[0].startsWith("de_"))
  const fr_images = FRENImgsArr.map((img, i) => {
    return {
      ...img[1].childImageSharp,
      title: captions[lang][i],
    }
  })

  return (
    <section id="gallery">
      <div className="my-6 mb-12 ml-10 max-w-3xl">
        <div className="flex flex-col items-start border-l-4 border-fehr-500 pl-3">
          <h2 className="mb-6">{strings[lang].title}</h2>
          <Button
            buttonString={strings[lang].btnString}
            buttonURL={strings[lang].btnURL}
          />
        </div>
      </div>
      <Gallery
        images={lang === "de" ? images : fr_images}
        colWidth={50}
        mdColWidth={20}
        rowMargin={0}
        gutter="0.10rem"
      />
    </section>
  )
}

export default PrecoThermiqueImageGallery
